export interface StrategyEvent {
  id?: string
  // Event WebSocket protocol uses UTC epoch milliseconds.
  timestamp: number
  level: LEVELS
  type: string
  message: string
}

export enum LEVELS {
  INFO = 'INFO',
  WARN = 'WARN',
  CRITICAL = 'CRITICAL'
}
